<template>
  <v-container fluid>
    <!-- <el-overlay-loading :loading="pageloading" /> -->
    <h3 class="mb-5">Duomenų naikinimas pagal aktą</h3>
    <naikinimas-aktas-search
      class="mt-1 mb-1"
      :loading="loading"
      @search="searchAktas"
      @cancel="cancelAktas"
    />

    <template v-if="showList">
      <v-data-table
        :loading="loading"
        :class="tableClass"
        :headers="headers"
        :items="itemsList"
        :hide-default-footer="hideFooter"
        :footer-props="{
          showFirstLastPage: true,
          showCurrentPage: true,
          itemsPerPageText: 'Rodyti po:',
          itemsPerPageAllText: 'visi',
          itemsPerPageOptions: itemsPerPageOptions,
        }"
        :sort-by.sync="pagination.sort"
        :sort-desc.sync="pagination.sortDesc"
        :server-items-length="pagination.total"
        :items-per-page="pagination.pageSize"
        :page.sync="pagination.page"
        @update:options="updatePagination"
        single-expand
        :expanded.sync="expanded"
        item-key="nak_id"
      >
        <template #[`item.bylos`]="{ item }">
          <el-byla
            v-for="byla in item.bylos"
            :key="byla.byl_id"
            :byla="byla"
            color="primary"
          />
        </template>
        <template #[`item.nak_busena`]="{ item }">
          <div class="mt-1 mb-1">
            <el-aktas-busena :busena="item.nak_busena" />
            <template v-if="item.isVykdoma">
              <div>{{ item.sunaikinta }}/{{ item.naikintinas_kiekis }}</div>
            </template>
          </div>
        </template>
        <template #[`item.nak_sukurimo_data`]="{ item }">
          <div class="nowrap">{{ item.nak_sukurimo_data_split.diena }}</div>
          <div class="nowrap">{{ item.nak_sukurimo_data_split.laikas }}</div>
        </template>
        <template #[`item.nak_dvs_data`]="{ item }">
          <div class="nowrap">{{ item.nak_dvs_data_split.diena }}</div>
        </template>
        <template #[`item.parametrai`]="{ item }">
          <el-switch
            class="mt-0 mb-2"
            v-model="item.expandedParametrai"
            @click.native="changeExpandedParametrai(item)"
          />
        </template>
        <template #[`item.actions`]="{ item }">
          <div class="nowrap">
            <el-button
              v-if="item.canNaikinti"
              class="my-0"
              x-small
              primary
              :key="`naikinti-${item.nak_id}`"
              :disabled="loading && !item.loading"
              :loading="item.loading"
              @click.native="aktasNaikinti(item)"
              >Naikinti</el-button
            >
            <el-button
              v-if="item.canFormuoti"
              class="my-0"
              x-small
              :key="`formuoti-${item.nak_id}`"
              :disabled="loading && !item.loading"
              :loading="item.loading"
              @click.native="aktasFormuoti(item)"
              >Performuoti</el-button
            >
            <v-tooltip top v-if="item.canDelete">
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  class="table-action mx-1"
                  dense
                  v-bind="attrs"
                  v-on="on"
                  @click="deleteItem(item)"
                >
                  mdi-delete-outline
                </v-icon>
              </template>
              <div class="tooltip-text">
                Šalinti
              </div>
            </v-tooltip>
          </div>
        </template>
        <template v-slot:expanded-item="{ headers, item }">
          <td></td>
          <td :colspan="headers.length - 1" class="ml-0 pl-0 pb-2">
            <naikinimas-aktas-parametrai
              :parametrai="item.nak_parametrai"
              :objektai="objektai"
              :loading="loading"
            />
          </td>
        </template>
        <template slot="loading">
          Kraunasi...
        </template>
        <template slot="no-results">
          Duomenų nėra
        </template>
        <template slot="no-data">
          Duomenų nėra
        </template>
        <template #[`footer.page-text`]="props">
          Rodoma {{ props.pageStart }}-{{ props.pageStop }} iš
          {{ props.itemsLength }}
        </template>
      </v-data-table>
    </template>

    <modal-aktas-naikinti
      v-model="showAktasNaikinti"
      :loading="loading"
      :item="itemAktasNaikinti"
      @confirmAktasNaikinti="confirmAktasNaikinti"
    />
    <modal-delete
      title="Šalinti duomenų naikinimo aktą?"
      :text="
        `Ar norite pašalinti duomenų naikinimo aktą <strong>Nr. ${modalDeleteVardas}</strong>?`
      "
      v-model="showDelete"
      :item="modalDeleteItem"
      @confirmDelete="confirmDelete"
    />
  </v-container>
</template>

<script>
import math from '../../mixins/math'
import NaikinimasAktasSearch from './NaikinimasAktasSearch'
import NaikinimasAktasParametrai from './NaikinimasAktasParametrai'
import ModalAktasNaikinti from '../modals/ModalAktasNaikinti'
import ModalDelete from '../modals/ModalDelete'

export default {
  name: 'NaikinimasAktas',
  components: {
    NaikinimasAktasSearch,
    NaikinimasAktasParametrai,
    ModalAktasNaikinti,
    ModalDelete,
  },
  mixins: [math],
  data() {
    return {
      pageloading: true,
      loading: false,
      searchData: {},
      aktai: [],
      objektai: {},
      itemsPerPageOptions: [3, 10, 50, 100],
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0,
        totalPages: 0,
        sort: null,
        sortDesc: [],
        direction: 'asc',
      },
      paginationloading: false,
      showList: false,
      showResult: false,
      resultMsg: null,
      expanded: [],
      showAktasNaikinti: false,
      itemAktasNaikinti: {},
      showDelete: false,
      modalDeleteVardas: null,
      modalDeleteItem: null,
    }
  },
  computed: {
    headers() {
      return [
        {
          text: 'Akto Nr.',
          align: 'center',
          value: 'nak_id',
          width: 80,
        },
        {
          text: 'Duomenų naikinimo aktas',
          align: 'center',
          value: 'bylos',
        },
        {
          text: 'Sukūrimo data',
          align: 'center',
          value: 'nak_sukurimo_data',
          width: 100,
        },
        {
          text: 'Aktą sugeneravęs asmuo',
          align: 'left',
          value: 'sukure',
        },
        {
          text: 'Duomenų naikinimo data',
          align: 'center',
          value: 'nak_naikinimo_data',
          width: 100,
        },
        {
          text: 'Akto būsena',
          align: 'center',
          value: 'nak_busena',
        },
        {
          text: 'DVS numeris',
          align: 'left',
          value: 'nak_dvs_numeris',
        },
        {
          text: 'DVS data',
          align: 'center',
          value: 'nak_dvs_data',
          width: 100,
        },
        {
          text: 'Duomenis naikinęs asmuo',
          align: 'left',
          value: 'naikino',
        },
        {
          text: 'Formavimo parametrai',
          align: 'center',
          value: 'parametrai',
          width: 80,
        },
        {
          text: 'Veiksmai',
          align: 'left',
          value: 'actions',
        },
      ]
    },
    filteredHeaders() {
      return this.headers.filter(item => {
        return !item.hide
      })
    },
    itemsList() {
      return this.aktai.map((item, index) => {
        item.nak_sukurimo_data_split = this.splitDate(item.nak_sukurimo_data)
        item.nak_naikinimo_data_split = this.splitDate(item.nak_naikinimo_data)
        item.nak_dvs_data_split = this.splitDate(item.nak_dvs_data)

        // item.expandedParametrai = false

        item.isVykdoma = item.nak_busena === 'vykdomas'

        item.bylos = item.bylos.map(byla => {
          byla.byl_tipas = `naikinimo_aktas`
          byla.byl_url = `byla/${byla.byl_id}/${byla.byl_hash}/content`
          return byla
        })

        item.canFormuoti = item.nak_busena === 'nesuformuota'
        item.canNaikinti = item.nak_busena === 'laukia_patvirtinimo'
        item.canDelete =
          item.nak_busena === 'nesuformuota' ||
          item.nak_busena === 'suformuota' ||
          item.nak_busena === 'laukia_patvirtinimo'

        return item
      })
    },
    hideFooter() {
      return this.pagination.total <= 10
    },
    tableClass() {
      return 'aktas-table'
    },
  },
  created() {
    this.getKlasif()
  },
  methods: {
    getKlasif() {
      const data = {
        klasifikatoriai: ['admin_aktas_objektai'],
      }

      this.$axios
        .post(`klasifikatorius/list`, data)
        .then(res => {
          this.objektai = res.data.list.admin_aktas_objektai
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {})
    },
    searchAktas(searchData) {
      this.searchData = searchData
      this.showResult = false
      this.getData(true)
    },
    cancelAktas() {
      this.searchData = {}
      this.aktai = []
      this.showList = false
      this.showResult = false
    },
    getData(resetPageNr = false) {
      this.pageloading = true
      this.loading = true

      if (resetPageNr) {
        this.pagination.page = 1
      }

      const data = {
        ...this.pagination,
        search: this.searchData,
      }

      this.$axios
        .post(`naikinimo-aktas/sarasas`, data)
        .then(res => {
          this.aktai = res.data.naikinimo_aktai
          this.pagination = { ...this.pagination, ...res.data.pagination }
          if (
            this.pagination.page === 1 &&
            this.aktai.length > 0 &&
            this.aktai[0].nak_busena === 'laukia_patvirtinimo'
          ) {
            this.aktai[0].expandedParametrai = true
            this.expanded = [this.aktai[0]]
          }
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
          this.paginationloading = false
          this.showList = true
          this.showAktasNaikinti = false
          this.showDelete = false
        })
    },
    updatePagination(pagination) {
      if (this.paginationloading) {
        return
      }
      this.pagination.page = pagination.page
      this.pagination.pageSize = pagination.itemsPerPage
      this.pagination.sort = pagination.sortBy[0]
      this.pagination.sortDesc = pagination.sortDesc
      this.pagination.direction = pagination.sortDesc[0] ? 'desc' : 'asc'

      if (!this.pageloading) {
        this.paginationloading = true
        this.getData()
      }
      this.pageloading = false
    },
    changeExpandedParametrai(item) {
      this.clearExpanded(item)
      if (item.expandedParametrai) {
        this.expanded = [item]
      } else {
        this.expanded = []
      }
    },
    clearExpanded(item) {
      this.aktai.forEach(e => {
        if (e.nak_id != item.nak_id) {
          e.expandedParametrai = false
        }
      })
    },
    aktasFormuoti(item) {
      this.loading = true
      item.loading = true

      this.$axios
        .post(`naikinimo-aktas/${item.nak_id}/performuoti`)
        .then(res => {
          window._VMA.$emit('DATA_OK', res.data.message)
          this.aktai = []
          this.getData()
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
          this.loading = false
          item.loading = false
        })
        .finally(() => {
          //item.loading = false
        })
    },
    aktasNaikinti(item) {
      this.itemAktasNaikinti = item
      this.showAktasNaikinti = true
    },
    confirmAktasNaikinti(item) {
      this.loading = true
      const data = {
        ...item,
      }

      this.$axios
        .post(`naikinimo-aktas/${item.nak_id}/naikinti`, data)
        .then(res => {
          window._VMA.$emit('DATA_OK', res.data.message)
          this.aktai = []
          this.getData()
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
          item.loading = false
          this.loading = false
        })
    },
    deleteItem(item) {
      this.modalDeleteVardas = item.nak_id
      this.modalDeleteItem = Object.assign({}, item)
      this.showDelete = true
    },
    confirmDelete(item) {
      this.loading = true

      this.$axios
        .delete(`naikinimo-aktas/${item.nak_id}`)
        .then(res => {
          window._VMA.$emit('DATA_OK', res.data.message)
          this.getData(true)
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
          this.showDelete = false
          this.loading = false
        })
    },
  },
}
</script>
<style lang="scss">
.aktas-table > .v-data-table__wrapper tbody tr.v-data-table__expanded__content {
  box-shadow: inset 0px -4px 8px -5px rgba(50, 50, 50, 0.75);
}
</style>
